import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes.ts';
import { mockedOneflightClientsData } from '@shared/mocks/requests/oneflightClients/oneflightClients.fixtures';

export const oneflightClientsRequests = [
  http.get(`*${apiRoutes.getOneFlightClients()}`, () => {
    return HttpResponse.json(mockedOneflightClientsData);
  }),
];
